var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id },
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("add-to-basket", {
            attrs: {
              "data-testing": "item-add-to-basket",
              "variation-id": _vm.item.variation.id,
              "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
              "has-children":
                !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
              "interval-quantity":
                _vm.item.variation.intervalOrderQuantity || 1,
              "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
              "maximum-quantity":
                !!_vm.item.variation.maximumOrderQuantity &&
                _vm.item.variation.maximumOrderQuantity > 0
                  ? _vm.item.variation.maximumOrderQuantity
                  : null,
              "order-properties": _vm.item.properties.filter(function (prop) {
                return prop.property.isOderProperty
              }),
              "has-order-properties": _vm.item.hasOrderProperties,
              "has-required-order-property": _vm.item.hasRequiredOrderProperty,
              "use-large-scale": true,
              "show-quantity": false,
              "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
              "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
              "has-graduated-price":
                _vm.itemGraduatedPriceisCheapestSorting ||
                _vm.itemGraduatedPricesalableVariationCount,
              "item-type": _vm.item.item.itemType,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1 cimage" },
              [
                _vm._t("item-image", function () {
                  return [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile,
                      },
                    }),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._t("store-special", function () {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType,
                    },
                  })
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details", function () {
            return [
              _c(
                "div",
                { staticClass: "thumb-content" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "thumb-title small",
                      class: {
                        "stretched-link":
                          _vm.$ceres.config.global.shippingCostsCategoryId == 0,
                      },
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("itemName")(_vm.item)) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isBook
                    ? _c("div", { staticClass: "item-details__book-details" }, [
                        _vm.item.texts.name3
                          ? _c(
                              "span",
                              { staticClass: "item-details__subtitle" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.item.texts.name3) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.texts.name2
                          ? _c(
                              "span",
                              { staticClass: "item-details__author" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.item.texts.name2) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.texts.shortDescription
                          ? _c("span", { staticClass: "item-details__short" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.item.texts.shortDescription) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability
                          ? _c(
                              "span",
                              {
                                class:
                                  "availability badge availability_" +
                                  _vm.item.variation.availability.id,
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.item.variation.availability.names
                                          .name
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumb-meta mt-2" },
                    [
                      _vm._t("before-prices"),
                      _vm._v(" "),
                      _c("div", { staticClass: "prices" }, [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value
                          ? _c("div", { staticClass: "price-view-port" }, [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price" },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              : _vm.itemGraduatedPriceisCheapestSorting
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              : _vm.itemGraduatedPricesalableVariationCount
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices"),
                  _vm._v(" "),
                  _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                    ? _c(
                        "div",
                        { staticClass: "category-lowest-price small" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemLowestPrice",
                                  {
                                    price:
                                      _vm.item.prices.default.lowestPrice
                                        .formatted,
                                  }
                                )
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !(
                    _vm.item.unit.unitOfMeasurement === "C62" &&
                    _vm.item.unit.content === 1
                  )
                    ? _c("div", { staticClass: "category-unit-price small" }, [
                        _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.item.unit.names.name)),
                        ]),
                        _vm._v(" "),
                        _vm.item.variation.mayShowUnitPrice
                          ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "vat small text-muted" }, [
                    _vm._v("\n                    * "),
                    _vm.showNetPrices
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.itemExclVAT")
                            )
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.itemInclVAT")
                            )
                          ),
                        ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.itemExclusive")
                        ) +
                        "\n                    "
                    ),
                    _vm.$ceres.config.global.shippingCostsCategoryId > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "text-appearance",
                            attrs: {
                              "data-toggle": "modal",
                              href: "#shippingscosts",
                              title: _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemShippingCosts"
                                )
                              )
                            ),
                          ]
                        )
                      : _c(
                          "a",
                          {
                            attrs: {
                              title: _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemShippingCosts"
                                )
                              )
                            ),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _vm.isBook
                    ? _c("div", { staticClass: "item-details__book-btn" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-appearance item-details__showItem",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.directToItem()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$translate("Ceres::Template.itemShowItem")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("add-to-basket", {
        attrs: {
          "variation-id": _vm.item.variation.id,
          "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
          "has-children":
            !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
          "interval-quantity": _vm.item.variation.intervalOrderQuantity || 1,
          "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
          "maximum-quantity":
            !!_vm.item.variation.maximumOrderQuantity &&
            _vm.item.variation.maximumOrderQuantity > 0
              ? _vm.item.variation.maximumOrderQuantity
              : null,
          "order-properties": _vm.item.properties.filter(function (prop) {
            return prop.property.isOderProperty
          }),
          "has-order-properties": _vm.item.hasOrderProperties,
          "has-required-order-property": _vm.item.hasRequiredOrderProperty,
          "use-large-scale": false,
          "show-quantity": false,
          "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
          "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
          "has-graduated-price":
            _vm.itemGraduatedPriceisCheapestSorting ||
            _vm.itemGraduatedPricesalableVariationCount,
          "item-type": _vm.item.item.itemType,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }